import React from "react"
import styled from "styled-components"
import media from "../../helpers/media"

const Wrapper = styled.h2`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid black;
  margin: 0;
  height: 50px;
  font-size: 20px;
  width: 100%;

  .white {
    color: var(--color-light);
  }

  img {
    width: 12px;
    transform: translateY(-5px);
    margin-right: 5px;
    margin-left: 4px;

    ${media.tablet} {
      width: 16px;
      transform: translateY(-7px);
      margin-right: 8px;
      margin-left: 9px;
    }
  }

  ${media.tablet} {
    font-size: 25px;
  }
`

interface IProps {
  content?: string | JSX.Element
}

const Title = ({ content }: IProps) => {
  return <Wrapper>{content}</Wrapper>
}

export default Title
